let controller1 = new ScrollMagic.Controller();

//secton2 
var box2_title=document.getElementsByClassName('box2_title');
let scene2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box2', 
        triggerHook: "onenter",
        duration:0,
})
scene2.on("progress", function (event) {
    box2_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box2_title[0].classList.remove("showup");
    }
})

//secton3
let scene3 = new ScrollMagic.Scene({
        offset: 150,
        triggerElement: '.box3', 
        triggerHook: "onenter",
        duration:0,
})
scene3.on("progress", function () {
    $('.box3_img').hide()
    $('.box3_img2').show()
})
let scene3_1 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box3', 
    triggerHook: "onenter",
    duration:0,
})
scene3_1.on("progress", function () {
$('.box3_img').hide()
$('.box3_img3').show()
})
let scene3_2 = new ScrollMagic.Scene({
        offset: 250,
        triggerElement: '.box3', 
        triggerHook: "onenter",
        duration:0,
})
scene3_2.on("progress", function () {
    $('.box3_img').hide()
    $('.box3_img4').show()
})
let scene3_3 = new ScrollMagic.Scene({
        offset: 300,
        triggerElement: '.box3', 
        triggerHook: "onenter",
        duration:0,
})
scene3_3.on("progress", function () {
    $('.box3_img').hide()
    $('.box3_img5').show()
})
let scene3_4 = new ScrollMagic.Scene({
        offset: 350,
        triggerElement: '.box3', 
        triggerHook: "onenter",
        duration:0,
})
scene3_4.on("progress", function () {
    $('.box3_img').hide()
    $('.box3_img6').show()
})


var box3_title=document.getElementsByClassName('box3_title');
let scene3_P = new ScrollMagic.Scene({
    offset: -60,
    triggerElement: '.box3',
    triggerHook: "0",
    duration:2500,
})
scene3_P.setPin('.box3');
scene3_P.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    for(var i=7; i<39;i++){
        if(index1>(i-6)*2.5){
            $('.box3_img').hide()
            $(`.box3_img${i}`).show()
        }
    }
    if(index1>90){
        box3_title[0].classList.add("showup");
    }
    if(index1<90){
        box3_title[0].classList.remove("showup");
    }

})

//secton4
var box4_title=document.getElementsByClassName('box4_title');
let scene4 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box4', 
        triggerHook: "onenter",
        duration:0,
})
scene4.on("progress", function (event) {
    box4_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box4_title[0].classList.remove("showup");
    }
})

//secton5
var box5_title=document.getElementsByClassName('box5_title');
let scene5 = new ScrollMagic.Scene({
        offset: 100,
        triggerElement: '.box5', 
        triggerHook: "onenter",
        duration:0,
})
scene5.on("progress", function (event) {
    box5_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_title[0].classList.remove("showup");
    }
})

var box5_items=document.getElementsByClassName('box5_items');
let scene5_1 = new ScrollMagic.Scene({
        offset: -50,
        triggerElement: '.box5', 
        triggerHook: "onenter",
        duration:0,
})
scene5_1.on("progress", function (event) {
    box5_items[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_items[0].classList.remove("showup");
    }
})

//secton6
var box6_title=document.getElementsByClassName('box6_title');
let scene6 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box6', 
        triggerHook: "onenter",
        duration:0,
})
scene6.on("progress", function (event) {
    box6_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box6_title[0].classList.remove("showup");
    }
})

//secton7
var box7_content=document.getElementsByClassName('box7_content');
let scene7 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box7', 
        triggerHook: "onenter",
        duration:0,
})
scene7.on("progress", function (event) {
    box7_content[0].classList.add("showup");
    box7_content[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box7_content[0].classList.remove("showup");
        box7_content[1].classList.remove("showup");
    }
})


controller1.addScene([scene2,scene3,scene3_P,scene3_1,scene3_2,scene3_3,scene3_4,scene4,scene5,scene6,scene7,scene5_1]); 

var box4Swiper = new Swiper('.box4Swiper', {
	loop:true,
    slidesPerView : 5,
    spaceBetween : '5%',
    autoplay: {
        disableOnInteraction: false,
      },
})
var Mbox4Swiper = new Swiper('.Mbox4Swiper', {
    autoplay: {
        disableOnInteraction: false,
    },
    loop:true,
    slidesPerView : 3,
    centeredSlides: true,
    on:{
        slideChangeTransitionEnd: function(){
            if(window.innerWidth<750){
                $('.Mbox4_text').css({opacity:'0'})
                $('.Mbox4Swiper .swiper-slide-active')[0].children[0].children[1].style.opacity = 1
            }
        },
      },
})

if(window.innerWidth>750){
    var box6Swiper = new Swiper('.box6Swiper', {
        slidesPerView : 5,
        centeredSlides: true,
        on:{
            slideChangeTransitionEnd: function(){
                if(window.innerWidth>750){
                    $('.box6_text').css({opacity:'0'})
                    $('.box6Swiper .swiper-slide-active')[0].children[0].children[1].style.opacity = 1
                }
            },
        },
        pagination: {
            el: '.box6_swiper-pagination',
            clickable :true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
    })

    $('.box6_icon').hover(function(){
        $(this).css({opacity:'0.5'})
    },function(){
        $(this).css({opacity:'1'})
    })
}else{ 
    var box6Swiper = new Swiper('.box6Swiper', {
        slidesPerView : 4.5,
        centeredSlides: true,
        on:{
            slideChangeTransitionEnd: function(){
                if(window.innerWidth<750){
                    $('.box6_text').css({opacity:'0'})
                    $('.box6Swiper .swiper-slide-active')[0].children[0].children[1].style.opacity = 1
                }
            },
        },
        pagination: {
            el: '.box6_swiper-pagination',
            clickable :true,
        },
    })
}


box6Swiper.activeIndex = 2;
box6Swiper.update()




$('.pnr_buy').click(function(){
    window.open(''); 
})

$('.pnr_spec').click(function(){
    var element = document.querySelector(".box7");
    element.scrollIntoView({block: "end"});
})

